import { ZoneMapView } from '../../zones/components/ZoneMapView.tsx';
import { OperatorParking } from '../../common/state/useParkingsFetch.ts';
import { useNavigate } from 'react-router';
import { EmptyResults } from '../../shared-mui-components/ListMessages.tsx';

export function ParkingsMap({ parkings }: { parkings: OperatorParking[] }) {
    const navigate = useNavigate();

    const zonesWithGeodata = parkings
        .filter(parking => parking.geodataText)
        .map(parking => {
            return {
                id: parking.zoneId,
                externalName: parking.name,
                geodataText: parking.geodataText,
            };
        });

    if (zonesWithGeodata.length < 1) {
        return <EmptyResults />;
    }

    return (
        <ZoneMapView
            zonesData={zonesWithGeodata}
            onZoneClick={(zoneId: number) => navigate(`${zoneId}`)}
        />
    );
}
